export const SUPPORTED_API_OPTIONS = [
  { label: "Staff", value: "get_staff_cch" },
  { label: "Location", value: "get_location_cch" },
  { label: "Office", value: "get_client_office_cch" },
  { label: "Group", value: "get_group_cch" },
  { label: "Client Type", value: "get_client_types" },
  { label: "Sub-Niche", value: "get_all_line_of_business_cch" },
  { label: "Niche", value: "get_all_primary_service_types_cch" },
  { label: "Client IDs", value: "get_client_id" },
  { label: "Client Name", value: "get_client_name" },
  { label: "Firm Name", value: "get_firm_name" },
  { label: "Referral Source", value: "get_referral_source" },
  { label: "Return Type", value: "get_return_type" },
  { label: "Client Status", value: "get_client_status" },
  { label: "State Province", value: "get_state_province" },
];
